import { render, staticRenderFns } from "./RecentResourceReport.vue?vue&type=template&id=6a03db42&"
import script from "./RecentResourceReport.vue?vue&type=script&lang=js&"
export * from "./RecentResourceReport.vue?vue&type=script&lang=js&"
import style0 from "./RecentResourceReport.vue?vue&type=style&index=0&id=6a03db42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports